export const TOGGLE_NOTIFICATION = "TOGGLE_NOTIFICATION";
export const NOTIFICATION_MENU = "NOTIFICATION_MENU";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const SINGLE_NOTIFICATION = "SINGLE_NOTIFICATION";
export const UNREAD_NOTIFICATION_COUNT = "UNREAD_NOTIFICATION_COUNT";
